import { Injectable } from '@angular/core';
import { MessengerService } from '../messenger/messenger.service';

export class RestProvider {

  public endpointName: string;

  constructor(endpointName: string, private ms: MessengerService) {
    this.endpointName = endpointName;
  }

  public find(params?: any): Promise<any> {
    return this.ms.find(this.endpointName, params ? params.query : undefined);
  }

  public get(id: string, params?: any): Promise<any> {
    return this.ms.get(this.endpointName, id, params ? params.query : undefined);
  }

  public create(data: any, params?: any): Promise<any> {
    return this.ms.create(this.endpointName, data, params ? params.query : undefined);
  }

  public update(id: string, data: any, params?: any): Promise<any> {
    return this.ms.update(this.endpointName, id, data, params ? params.query : undefined);
  }

  public patch(id: string, data: any, params?: any): Promise<any> {
    return this.ms.patch(this.endpointName, id, data, params ? params.query : undefined);
  }

  public remove(id: string, params?: any): Promise<any> {
    return this.ms.remove(this.endpointName, id, params ? params.query : undefined);
  }

}

@Injectable()
export class RestService {

  constructor(private ms: MessengerService) {
  }

  public createProvider(name: string): RestProvider {
    return new RestProvider(name, this.ms);
  }
}
